export default function confirmIdentity(continueTo: string = getCurrentUrl()): void {
    window.location.replace(getConfirmIdentityURL(continueTo));
}

export function getConfirmIdentityURL(continueTo: string = getCurrentUrl()): string {
    return '/confirm-identity?continue=' + encodeURIComponent(continueTo);
}

function getCurrentUrl(): string {
    const { pathname, search, hash } = window.location;
    return pathname + search + hash;
}
